var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"backdrop-files"},[_c('feather-icon',{staticClass:"mb-2",attrs:{"icon":"UploadCloudIcon","size":"90"}}),_c('h4',[_vm._v(_vm._s(_vm.text))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }